import {hasZipSignature,isZipUploadMetadata,officeContainerUploadExtensions,uploadExtension,ZIP_UPLOAD_MESSAGE} from '@myfm/domain';
import {reviewedApplicationError} from './state-contract';

export async function assertUploadFile(file:File):Promise<void> {
  if(isZipUploadMetadata(file.name,file.type))throw reviewedApplicationError(`${file.webkitRelativePath||file.name}: ${ZIP_UPLOAD_MESSAGE}`);
  let prefix:Uint8Array;
  try{prefix=new Uint8Array(await file.slice(0,4).arrayBuffer());}catch{
    // Existing upload preparation reports unavailable/cloud-only files and can retain readable siblings.
    return;
  }
  // The server verifies Office container contents before storing any new bytes.
  if(hasZipSignature(prefix)&&!officeContainerUploadExtensions.has(uploadExtension(file.name)))throw reviewedApplicationError(`${file.webkitRelativePath||file.name}: ${ZIP_UPLOAD_MESSAGE}`);
}
